<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Laskutus</h2>
            <p>Tässä näet yrityksen laskutuskertymän</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text "></h2>
                                <p class="white-text">Yritystä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">+100</h2>
                                <p class="white-text">lääkäriä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">10</h2>
                                <p class="white-text">Avattua profiilia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <div class="col-12 d-flex">
            <div class="form-floating mb-2  me-2">
                <input type="date" placeholder="Alku" id="start" class="form-control" required>
                <label for="start">Alku</label>
            </div>
            <div class="form-floating mb-2 me-2 p-0">
                <input type="date" placeholder="Loppu" id="end" class="form-control" required>
                <label for="end">Loppu</label>
            </div>
            <button class="btn btn-formed-main-black">Etsi</button>
        </div>
        <div class="table-responsive" *ngIf="billings && billings.length > 0;else no_answers_content">
            <table class="table align-items-center table-flush">
                <thead class="thead-light">
                    <tr>
                        <th>Päivämäärä</th>
                        <th>Nimike</th>
                        <th>Kustannuspaikka</th>
                        <th>Yksikköhinta</th>
                        <th>Kappalemäärä</th>
                        <th>Summa (alv 0%)</th>
                    </tr>
                </thead>
                <tbody class="tbody-light">
                    <tr *ngFor="let data of billings">
                        <td>{{data.createdDate | formateDate}}</td>
                        <td>{{data.name}}</td>
                        <td>
                          <span *ngIf="!data.cost_center">
                          
                          </span>
                          <span *ngIf="data.cost_center">
                              {{data.cost_center}}
                          </span>
                          </td>
                        <td>
                          <span *ngIf="!data.unit_price">
                          0
                          </span>
                          <span *ngIf="data.unit_price">
                              {{data.unit_price}}
                          </span>
                          </td>
                        <td>
                          <span *ngIf="!data.qty">
                              0
                              </span>
                              <span *ngIf="data.qty">
                                  {{data.qty}}
                              </span>
                          </td>
                        <td>{{data.price}}€</td>
                    </tr>
                </tbody>
                <tbody class="tbody-light">
                    <tr>
                        <td class="bold">Yhteensä:</td>
                        <td>{{finalSum}}€</td>
                        <td></td>
                    </tr>
                </tbody>

            </table>
        </div>
        <ng-template #no_answers_content>
            <div class="col-12 row m-0">
                <div class="col-3"></div>
                <div class="col-12 col-md-6">
                    <div class="alert alert-warning">
                        <p class="normal-text text-center">Et ole tehnyt vielä mitään josta kertyy kuluja.</p>
                    </div>
                </div>
                <div class="col-3"></div>
            </div>
        </ng-template>
        </div>

        <div class="col-1"></div>
  </div>

  </div>

    </div>